/**
 * 後台「選櫃」：排除他人租借中格位；空置、僅過期、僅本人使用中者可選。
 * @param {{ number: number, occupants?: Array<{ memberId:number, expired?:boolean, needsVacatedAck?:boolean }> }[]} slots
 * @param {number|string|undefined|null} currentMemberId
 * @returns {{ number:number|string, needsVacatedAck:boolean, duplicateWarn:boolean, variant:string }[]}
 */
export function buildSelectableLockerOptions(slots, currentMemberId) {
  const mid =
    currentMemberId != null && String(currentMemberId).trim() !== ''
      ? Number(currentMemberId)
      : NaN;
  const out = [];
  for (const slot of slots || []) {
    const occ = slot.occupants || [];
    const n = slot.number;
    if (!occ.length) {
      out.push({ number: n, needsVacatedAck: false, duplicateWarn: false, variant: 'vacant' });
      continue;
    }
    const othersActive = occ.some((o) => !o.expired && Number(o.memberId) !== mid);
    if (othersActive) continue;

    const needsVacatedAck = occ.some((o) => o.needsVacatedAck);
    const duplicateWarn = occ.length > 1;
    const onlySelfActive =
      occ.some((o) => !o.expired && Number(o.memberId) === mid) &&
      occ.every((o) => o.expired || Number(o.memberId) === mid);

    if (needsVacatedAck) {
      out.push({ number: n, needsVacatedAck: true, duplicateWarn, variant: 'expired_unconfirmed' });
    } else if (onlySelfActive && !duplicateWarn) {
      out.push({ number: n, needsVacatedAck: false, duplicateWarn: false, variant: 'self_renew' });
    } else if (duplicateWarn) {
      out.push({ number: n, needsVacatedAck: false, duplicateWarn: true, variant: 'duplicate_cleared' });
    } else {
      out.push({ number: n, needsVacatedAck: false, duplicateWarn: false, variant: 'expired_cleared' });
    }
  }
  out.sort((a, b) => Number(a.number) - Number(b.number));
  return out;
}

export function lockerOptionLabel(opt) {
  const n = opt.number;
  switch (opt.variant) {
    case 'vacant':
      return `${n} 號櫃（空置）`;
    case 'self_renew':
      return `${n} 號櫃（目前租約／續期）`;
    case 'expired_unconfirmed':
      return `${n} 號櫃 — 已到期未確認退租${opt.duplicateWarn ? '（多筆紀錄）' : ''}`;
    case 'duplicate_cleared':
      return `${n} 號櫃（多筆過期紀錄，請確認後選用）`;
    case 'expired_cleared':
      return `${n} 號櫃（前租約已過期，可分配）`;
    case 'orphan':
      return `${n} 號櫃（列表未同步，請確認）`;
    default:
      return `${n} 號櫃`;
  }
}
